import { applyMiddleware, createStore, compose } from "redux";
import thunk from "redux-thunk";
import reducers from "../reducers";
import api from "../api/api";
import cxaApi from "../api/flexapi";

const thunkWithExtraArg = thunk.withExtraArgument(cxaApi);
const middleware = applyMiddleware(thunkWithExtraArg, api);

export default function configureStore(initialState = {}) {
  return createStore(reducers, initialState, compose(middleware));
}



// WEBPACK FOOTER //
// ./store/configureStore.prod.js